import { ToastUtil } from '../utils/toast.util';
import {
  getMarketplacesApi,
  getMarketplaceApi,
  updateMarketplaceApi,
  getMarketplacesListApi,
  getMarketplaceRateLimitApi,
} from './marketplaces.api';

export const getMarketplacesReducers = (builder) => {
  builder
    .addCase(getMarketplacesApi.pending, (state) => {
      state.getMarketplacesStatus = 'pending';
    })
    .addCase(getMarketplacesApi.fulfilled, (state, { payload }) => {
      state.getMarketplacesStatus = 'success';
      state.marketplaces = payload.marketplaces;
      state.totalMarketplaces = payload.totalCount;
      state.totalPages = payload.totalPages;
      state.currentPage = payload.currentPage;
    })
    .addCase(getMarketplacesApi.rejected, (state, action) => {
      state.getMarketplacesStatus = 'failed';
      state.error = action?.error?.message;
    });
};

export const getMarketplaceReducers = (builder) => {
  builder
    .addCase(getMarketplaceApi.pending, (state) => {
      state.getMarketplaceStatus = 'pending';
      state.error = null;
    })
    .addCase(getMarketplaceApi.fulfilled, (state, { payload }) => {
      state.getMarketplaceStatus = 'fulfilled';
      state.marketplace = payload;
      state.error = null;
    })
    .addCase(getMarketplaceApi.rejected, (state, action) => {
      state.getMarketplaceStatus = 'rejected';
      state.error = action?.error?.message;
    });
};

export const updateMarketplaceReducers = (builder) => {
  builder
    .addCase(updateMarketplaceApi.pending, (state) => {
      state.updateMarketplaceStatus = 'pending';
      state.error = null;
    })
    .addCase(updateMarketplaceApi.fulfilled, (state, { payload }) => {
      const response = payload;
      state.updateMarketplaceStatus = 'fulfilled';
      state.marketplace = payload.data;
      state.error = response.message;

      ToastUtil.handleApiResponse(response, 'Update Successful', 'Update Failed');
    })
    .addCase(updateMarketplaceApi.rejected, (state, action) => {
      state.updateMarketplaceStatus = 'rejected';
      state.error = action?.error?.message;
      ToastUtil.error(
        'Update failed',
        action?.error?.message || 'Failed to update marketplace',
      );
    });
};

export const getMarketplacesListReducers = (builder) => {
  builder
    .addCase(getMarketplacesListApi.pending, (state) => {
      state.getMarketplacesListStatus = 'pending';
    })
    .addCase(getMarketplacesListApi.fulfilled, (state, { payload }) => {
      state.getMarketplacesListStatus = 'fulfilled';
      state.list = payload;
    })
    .addCase(getMarketplacesListApi.rejected, (state, action) => {
      state.getMarketplacesListStatus = 'rejected';
      state.error = action?.error?.message;
    });
};

export const getMarketplaceRateLimitReducers = (builder) => {
  builder
    .addCase(getMarketplaceRateLimitApi.pending, (state) => {
      state.getMarketplaceRateLimitStatus = 'pending';
    })
    .addCase(getMarketplaceRateLimitApi.fulfilled, (state, { payload }) => {
      state.getMarketplaceRateLimitStatus = 'fulfilled';
      state.rateLimit = payload;
    })
    .addCase(getMarketplaceRateLimitApi.rejected, (state, action) => {
      state.getMarketplaceRateLimitStatus = 'rejected';
      state.rateLimit = null;
      state.error = action?.payload || action?.error?.message;
    });
};
